import React from 'react';
import { UI } from 'src/apps/invest/signup/views/components/UI';
import { useSignUpModel } from '../../models/SignUpModel';
import { NameForm } from '../components/NameForm';
import { Transition } from '../components/Transition';

export const SignUpNamePage: React.FC = () => {
  const { firstName, lastName } = useSignUpModel();

  return (
    <UI
      prevPage={() => useSignUpModel.setState({ page: 'PASSWORD' })}
      nextPage={firstName && lastName ? () => useSignUpModel.setState({ page: 'PHONE' }) : undefined}>
      <Transition>
        <NameForm />
      </Transition>
    </UI>
  );
};
